module.exports = __webpack_public_path__ + "img/Chef_GabyRuiz.b2471bcb.png";